<template>
  <div class="atenCamera">
     <div class="banner">
        <img class="banner_bg" src="@/assets/images/atenCamera/yqm-banner.png" alt="">
     <div class="right">
         <img src="@/assets/images/atenCamera/title.png" alt>
         <!-- <div class="button">在线咨询</div> -->
     </div>
     <div class="left">
        <img src="@/assets/images/atenCamera/small-banner.png" alt="">
     </div>
    </div>
   <div class="main">
     <div class="introduction">
        <img class="introduction_bg" src="@/assets/images/atenCamera/introduction.png" alt="">
       <div>
         <div class="title" style="margin-top:50px;">简介</div>
         <div class="info text" style="width:980px">云千目助力企业打破巡店的空间距离限制，排除人为差异化因素，高效、精准、透明的获得巡店数据，实现企业的高效化标准化管理。</div>
       </div>
        <img style="vertical-align:bottom;display:inline-block;z-index:1;" src="@/assets/images/atenCamera/introduction-info.png" alt="">
    </div>
    <div>
       <div class="item">
         <div class="title" style="margin-top:160px">智慧巡店标准化流程</div>
         <div class="info info-box" style="display:flex;margin-top:144px">
            <div class="info-start"  @mouseenter.stop="show1 = !show1" @mouseleave.stop="show1 = !show1">
                <div class="left-top">第一步</div>
                <div class="img-box">
                    <div><img style="width:126px" src="@/assets/images/atenCamera/plan.png" alt=""></div>
                    <div class="text">巡查计划</div>
                </div>
                <transition name="lc">
                    <div class="info-detail step1" v-if="show1">
                        <div><span class="circle"></span>创建评分模板</div>
                        <div><span class="circle"></span>创建考评计划</div>
                        <div><span class="circle"></span>新建巡店任务</div>
                    </div>
                </transition>
             </div>
            <div style="width:40px;height:22px;margin:auto 0;"><img src="@/assets/images/atenCamera/step.png" alt=""></div>
            <div class="info-start"  @mouseenter.stop="show2=!show2" @mouseleave.stop="show2=!show2">
                <div class="left-top">第二步</div>
                <div  class="img-box">
                    <div><img style="width:126px" src="@/assets/images/atenCamera/action.png" alt=""></div>
                    <div class="text">执行巡店</div>
                </div>
                <transition name="lc">
                    <div class="info-detail step2" v-if="show2">
                        <div><span class="circle"></span>实时视频</div>
                        <div><span class="circle"></span>视频回放</div>
                        <div><span class="circle"></span>图片巡检</div>
                    </div>
                </transition>
             </div>
           <div style="width:40px;height:22px;margin:auto 0;"><img src="@/assets/images/atenCamera/step.png" alt=""></div>
           <div class="info-start" @mouseenter.stop="show3=!show3" @mouseleave.stop="show3=!show3">
                <div class="left-top">第三步</div>
                <div  class="img-box">
                    <div><img style="width:126px" src="@/assets/images/atenCamera/find.png" alt=""></div>
                    <div class="text">发现问题</div>
                </div>
                <transition name="lc" >
                    <div class="info-detail step3" v-if="show3">
                        <div class="step3-box">
                            <div><span class="circle"></span>录制视频</div>
                            <div><span class="circle"></span>截图取证</div>
                            <div><span class="circle"></span>编辑标注</div>
                            <div><span class="circle"></span>实时对讲</div>
                        </div>
                    </div>
                </transition>
             </div>
           <div style="width:40px;height:22px;margin:auto 0;"><img src="@/assets/images/atenCamera/step.png" alt=""></div>
           <div class="info-start" @mouseenter.stop="show4=!show4" @mouseleave.stop="show4=!show4">
                <div class="left-top">第四步</div>
                <div  class="img-box">
                    <div><img style="width:126px" src="@/assets/images/atenCamera/auditing.png" alt=""></div>
                    <div class="text">整改审核</div>
                </div>
                <transition name="lc">
                    <div class="info-detail step4" v-if="show4">
                <div><span class="circle"></span>巡查员考评</div>
                <div><span class="circle"></span>店长整改 &nbsp;&nbsp;</div>
                <div><span class="circle"></span>巡查员审核</div>
            </div>
                </transition>
             </div>

           <div style="width:40px;height:22px;margin:auto 0;"><img src="@/assets/images/atenCamera/step.png" alt=""></div>
           <div class="info-start" @mouseenter.stop="show5=!show5" @mouseleave.stop="show5=!show5">
                <div class="left-top">第五步</div>
                <div  class="img-box">
                    <div><img style="width:126px" src="@/assets/images/atenCamera/static.png" alt=""></div>
                    <div class="text">报告统计</div>
                </div>
                <transition name="lc">
                    <div class="info-detail step5" v-if="show5">
                <div><span class="circle"></span>门店统计</div>
                <div><span class="circle"></span>问题统计</div>
                <div><span class="circle"></span>人员统计</div>
            </div>
                </transition>
             </div>

         </div>
       </div>
        <div class="item">
            <div class="title" style="margin-top:160px;margin-bottom:150px">全面提升巡店效率</div>
            <div class="info info-bg">
                <div style="width:372px;position: relative;" class="info-item">
                    <div ><img class="item-img" src="@/assets/images/atenCamera/shop.png" alt=""> <div class="item-text">巡店模式</div></div>
                    <div class="detail-info">线上、现场、考评、巡检等多种模式满足不同巡店场景</div>
                </div>
                 <div style="width:372px;position: relative;" class="info-item">
                    <div><img class="item-img" src="@/assets/images/atenCamera/circle.png" alt=""> <div class="item-text">流程闭环</div></div>
                    <div class="detail-info">通过考评-整改-审核标准化流程形成闭环提高管理效率，降低运营成本</div>
                </div>
                 <div style="width:372px;position: relative;" class="info-item">
                    <div><img class="item-img" src="@/assets/images/atenCamera/ceng.png" alt=""> <div class="item-text">层级管理</div></div>
                    <div class="detail-info">自定义组织架构，按照总部、区域、门店等多层级分组管理</div>
                </div>
                 <div style="width:372px;position: relative;" class="info-item">
                    <div><img class="item-img" src="@/assets/images/atenCamera/AI.png" alt=""> <div class="item-text">AI赋能</div></div>
                    <div class="detail-info">基于AI技术，智能部分检测违规项，系统自动截图，提升巡检及管理效率</div>
                </div>
                 <div style="width:372px;position: relative;" class="info-item">
                    <div><img class="item-img" src="@/assets/images/atenCamera/more.png" alt=""> <div class="item-text">多后台支持</div></div>
                    <div class="detail-info">支持网页浏览器及APP(Android和iOS)后台管理</div>
                </div>
            </div>
        </div>
        <div class="item" style="margin-top:160px">
            <div class="title">硬件支持</div>
            <p class="text">支持接入萤石云，乐橙云，宇视云…</p>
            <div class="info" style="margin-bottom:160px">
                <img style="margin-right: 130px;" src="@/assets/images/atenCamera/haikang.png" alt="">
                <img style="margin-right: 130px;" src="@/assets/images/atenCamera/TP-LINK.png" alt="">
                <img  src="@/assets/images/atenCamera/dahua.png" alt="">
            </div>
        </div>
    </div>
   </div>
  </div>
</template>

<script>
export default {
    name:'atenCamera',
    data(){
        return {
            show1:false,
            show2:false,
            show3:false,
            show4:false,
            show5:false
        }
    }
}
</script>

<style scoped>
.main {
    text-align: center;
}
.banner_bg {
    width: 100%;
    position: absolute;
    top:0;
    right:0;
    width: 100%;
}
.banner {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 700px;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.banner .right{
    z-index:1;
    width: 30%;
    max-width: 575px;
}
.banner .left{
    z-index:1;
    margin-left: 65px;
    width: 26%;
    max-width: 500px;
}
.banner .right img,.banner .left img {
    width: 100%;
}
.button {
    width: 205px;
    height: 50px;
    background: #0054dc;
    border-radius: 6px;
    color:#fff;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    margin-top:52px;
    cursor: pointer;
}
.introduction {
    height: 712px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    /* background:url('~') no-repeat center; */
    background-size:100%;
    position: relative;
}
.introduction_bg {
    position: absolute;
    top:0;
    right: 0;
}
.title {
    font-size: 50px;
    margin-bottom: 30px;
    font-weight: 600;
}

.item p {
    margin-bottom: 116px;
}
.info  {
    margin: 0 auto;
}
.text {
    color: #3B436B;
    font-size: 22px;
}
.info-item {
    text-align: left;
}
.item-text {
    display: inline-block;
    font-size: 26px;
    color: #303133;
    font-weight: 600;
    padding-left:60px;
    height: 60px;
}
.item-img {
    display: inline-block;
    position: absolute;
    top:-30px;
    left:-30px;
}
.info-box {
    width: 1200px;
}
.info-detail {
    line-height: 20px;
    font-size: 14px;
    width: 208px;
    height: 292px;
    border-radius: 4px;
    padding-top: 14px;
    color:#fff;
    cursor: pointer;
    position: absolute;
    top:0;
    right:0;
}
.info-detail>div {
   margin-bottom: 12px;
}
.info-detail .circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin-right: 12px;
}
.step1 {
    background:url('~@/assets/images/atenCamera/step1.png');
}
.step2 {
    background:url('~@/assets/images/atenCamera/step2.png');
}
.step3 {
    background:url('~@/assets/images/atenCamera/step3.png');
}
.step3-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: start;
    height: 80px;
}
.step4 {
    background:url('~@/assets/images/atenCamera/step4.png');
}
.step5 {
    background:url('~@/assets/images/atenCamera/step5.png');
}
.info-start{
    line-height: 20px;
    font-size: 14px;
    width: 208px;
    height: 292px;
    background-color: #F6F8FA;
    border-radius: 4px;
    color:#fff;
    cursor: pointer;
    position: relative;
}
.info-start .left-top {
    width: 61px;
    height: 25px;
    background:url('~@/assets/images/atenCamera/step-bg.png');
    text-align: center;
    padding-top: 3px;
}
.info-start .text {
    color: #606266;
    font-weight: 600;
    font-size: 22px;
    margin-top: 33px;
}
.info-bg {
    background: url('~@/assets/images/atenCamera/info-bg.png') no-repeat;
    width:1043px;
    padding-left:22px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.detail-info {
    font-size: 22px;
    color: #303133;
    margin-bottom: 90px;
}
.img-box {
    height:250px;
    display:flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
}
.lc-enter,.lc-leave-to{
        opacity: 0;
    }
    .lc-enter-to,.lc-leave{
        opacity: 1;
    }
    .lc-enter-active,.lc-leave-active{
        transition: all 1s;
    }
</style>



// WEBPACK FOOTER //
// src/components/atenCamera.vue